import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'src/components/Button';
import djangoContextHelper from 'src/utils/django-context-helper';
import Icons from 'src/components/Icons';
import useWindowWidth from 'src/utils/hooks/useWindowWidth';
import { switchLang } from 'src/utils/lang';

import styles from './Header.module.scss';

const Header = () => {
  const { user } = djangoContextHelper();
  const { i18n, t } = useTranslation();
  const { t: tHeader } = useTranslation('header');
  const handleSwitchLang = useCallback(() => {
    const newLang = switchLang();
    i18n.changeLanguage(newLang);
  }, [i18n]);
  const windowWidth = useWindowWidth();
  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <a href="/">
          <div className={styles.logo}>
            {windowWidth <= 768 ? <Icons.Logo /> : <Icons.LogoText className={styles.text} />}
          </div>
        </a>
        <a href="/schedule">
          <div className={styles.nav}>{tHeader('schedule')}</div>
        </a>
        <a href="/pricing">
          <div className={styles.nav}>{tHeader('pricing')}</div>
        </a>
      </div>
      <div className={styles.right}>
        <button className={styles.langSwitch} type="button" onClick={handleSwitchLang}>
          EN / CH
        </button>
        <a href={user ? '/user' : '/user/sign-in'}>
          {windowWidth <= 768 ? (
            <Icons.User className={styles.icon} />
          ) : (
            <Button type="primary">{user ? t('my-page') : t('sign-in')}</Button>
          )}
        </a>
      </div>
    </header>
  );
};

export default Header;
